// DailyTotals component
import {
  Card, Stack, Divider,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { AnalyticItem } from '@mgm/common/components';
import ScrollBar from '@mgm/common/components/ScrollBar';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getDailyStateSelectedLocation, getOrdersTotals } from '../../../../store/orders/selectors';
import { getCurrencyByCode } from '../../../../store/common/selectors';

const DailyTotals = () => {
  const { t } = useTranslation(['dashboard', 'common']);

  const dailyStateSelectedLocation = useAppSelector(getDailyStateSelectedLocation);
  const getCurrency = useAppSelector(getCurrencyByCode);
  const ordersTotals = useAppSelector(getOrdersTotals);

  const dailyTotals = useMemo(() => {
    if (dailyStateSelectedLocation === 0) {
      return Object.values(ordersTotals).reduce(
        (acc, totals) => {
          acc.salesTotal += totals.salesTotal;
          acc.totalOrders += totals.totalOrders;
          acc.productsTotal += totals.productsTotal;
          return acc;
        },
        { salesTotal: 0, totalOrders: 0, productsTotal: 0 },
      );
    }

    // Return totals for the selected location
    return ordersTotals[dailyStateSelectedLocation] || { salesTotal: 0, totalOrders: 0, productsTotal: 0 };
  }, [dailyStateSelectedLocation, ordersTotals]);

  return (
    <Card
      sx={{
        height: '88px',
      }}
    >
      <ScrollBar>
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem sx={{ borderStyle: 'dashed' }} />}
          sx={{ p: 2 }}
        >
          <AnalyticItem
            title={t('sales')}
            percent={100}
            price={`${(dailyTotals.salesTotal || 0)?.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${getCurrency().mark}`}
            icon="pepicons-print:coins"
            color="#36B37E"
          />
          <AnalyticItem
            title={t('ordersFulfilled', { ns: 'common' })}
            percent={100}
            price={dailyTotals.totalOrders || 0}
            icon="solar:bag-3-linear"
            color="rgb(255, 171, 0)"
          />
          <AnalyticItem
            title={t('productsSold')}
            percent={100}
            price={dailyTotals.productsTotal || 0}
            icon="fluent-mdl2:product-variant"
            color="rgb(0, 184, 217)"
          />
        </Stack>
      </ScrollBar>
    </Card>
  );
};

export {
  DailyTotals,
};
